import axios from 'axios';

const practiseid = 9928;

const hubApi = axios.create({
  baseURL: 'https://api.prd.brainymed.com/ag',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

hubApi.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('auth');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      
      sessionStorage.removeItem('auth');
      // window.location.replace('/auth');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;

const refreshAuthToken = async () => {
  try {
    const accessToken = sessionStorage.getItem('auth');
    const response = await hubApi.post(
      `/v1/${practiseid}/auth/refresh-token`,
      { access_token: accessToken },
      { headers: { 'Content-Type': 'application/json' } }
    );

    if (response && response.status === 200) {
          sessionStorage.setItem('auth', response.refresh_token);
      return response.refresh_token;
    } else {
      window.location.replace('/login');
      throw new Error('Failed to refresh token');
    }
  } catch (error) {
    window.location.replace('/login');
    console.error('Failed to refresh token:', error);
    throw error;
  }
};

hubApi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const newToken = await refreshAuthToken();
          if (newToken) {
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            isRefreshing = false;

            return hubApi(originalRequest);
          }
        } catch (refreshError) {
          isRefreshing = false;
          return Promise.reject(refreshError);
        }
      } else {
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default hubApi;
